import React from "react";

interface StatRowProps {
  label: string;
  value: string | number;
  valueLabel?: string | string[];
  subValue?: string;
  className?: string;
}

const StatRow: React.FC<StatRowProps> = ({
  label,
  value,
  valueLabel,
  subValue,
  className = "",
}) => (
  <div
    className={`flex justify-between items-center py-2 ${className} min-h-[60px]`}
  >
    <span className="text-gray-600 text-[12px]">{label}</span>
    <div className="text-right flex flex-col items-end">
      <div className="text-[#0A2E47] text-lg leading-none font-bold">
        {Array.isArray(value)
          ? value.map((v, i) => (
              <div className="text-md" key={i}>
                {i > 0 && <span className="text-gray-500 "> | </span>}
                {v}{" "}
                <span className="text-gray-500 text-[10px]">
                  {" "}
                  {valueLabel?.[i]}
                </span>
              </div>
            ))
          : value}
        {valueLabel && !Array.isArray(valueLabel) && (
          <span className="text-gray-500 text-[10px]"> {valueLabel}</span>
        )}
      </div>
      {subValue && <div className="text-gray-600 text-[10px]">{subValue}</div>}
    </div>
  </div>
);

interface StatCardProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  stats: Array<{
    label: string;
    value: string | number;
    valueLabel?: string | string[];
    subValue?: string;
  }>;
  iconBg?: string;
  className?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  subtitle,
  icon,
  stats,
  iconBg,
  className = "",
}) => {
  return (
    <div className={`bg-white rounded-lg pt-6 px-6 pb-2 ${className}`}>
      <div className="flex items-center gap-3 border-b border-[#E5E7EB] pb-3">
        {icon && (
          <div
            className="flex items-center justify-center rounded-lg px-2 py-2"
            style={{ backgroundColor: iconBg || "white" }}
          >
            {icon}
          </div>
        )}
        <div>
          <h2 className="text-[16px] font-semibold text-[#0A2E47]">
            {title}{" "}
            {subtitle && (
              <span className="text-gray-500 text-[10px]">({subtitle})</span>
            )}
          </h2>
        </div>
      </div>

      <div className="divide-y">
        {stats.map((stat, index) => (
          <StatRow
            key={index}
            label={stat.label}
            value={stat.value}
            valueLabel={stat.valueLabel}
            subValue={stat.subValue}
          />
        ))}
      </div>
    </div>
  );
};

export default StatCard;
